<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <span v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img draggable="false" class="background_image" src="./assets/images/Asset 32.png" alt="">
      <img draggable="false" id="house_image" src="./assets/images/Asset 31.png" alt="">
      <img draggable="false" id="right_line" src="./assets/images/Asset 27.png" alt="">
      <img draggable="false" id="left_line" src="./assets/images/Asset 28.png" alt="">

      <img draggable="false" class="clickable" @click="goToStartPage()" id="start_btn" src="./assets/images/Asset 30.png" alt="">
      <img draggable="false" id="logo" src="./assets/images/Asset 48.png" alt="">
      <img draggable="false" class="clickable" id="quit_btn" src="./assets/images/Asset 29.png" alt="">
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    // document.getElementById('video').play();
    this.checkLandscape()
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {};
  },

  methods: {
    goToStartPage() {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },
    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/feest/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }
  .background_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  .swal_html {
    font-family: "LuckiestGuy";
    src: url('./assets/feest/fonts/LuckiestGuy-Regular.ttf') format('truetype');
    font-size: 4vw;
    color: #739033;
  }

  .swal2-styled {
    font-family: "LuckiestGuy";
    src: url('./assets/feest/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  #house_image {
    position: absolute;
    margin-top: -3%;
    left: 5%;
    width: 90%;
  }

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  #start_btn {
    position: absolute;
    margin-top: 42%;
    left: 20%;
    width: 20%;
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
  }

  .cursor:hover {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
  }

  #quit_btn {
    position: absolute;
    margin-top: 42%;
    left: 57%;
    width: 20%;
  }

  #logo {
    position: absolute;
    margin-top: 6%;
    left: 38%;
    width: 15%;
  }

  #left_line {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 40%;
  }

  #right_line {
    position: absolute;
    top: 0%;
    right: 0%;
    width: 40%;
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

</style>
